import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {RmNormalizadorService} from '../../services/rm-normalizador.service';
import {NormalizadorService} from '../../../amena/services/normalizador.service';
import {DigoService} from '../../../services/digo.service';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-cobertura',
    templateUrl: './rm-cobertura.component.html',
    styleUrls: ['./rm-cobertura.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmCoberturaComponent implements OnInit, OnDestroy {
    @Input() formGroup: FormGroup;

    formularioNormalizacion: FormGroup;

    pdv: any;
    typeOrder: string;

    muestraCobertura: boolean;
    muestraErrorPeticion = false;
    muestraBotonesCobertura = false;
    muestraBotonNinguna = false;
    isLoading = false;
    textDefault = 'Comprobar cobertura';
    datosNormalizacion: any = null;
    localidades: any = null;
    direccionesSugeridas: any = null;
    plantas: any = null;
    bisOption: any = null;
    bloqueOption: any = null;
    bloqueLabel: any = null;
    portalOption: any = null;
    escaleraOption: any = null;
    tipoPuertaOption: any = null;
    puertaOption: any = null;
    consulta: any = null;
    msgErrorPeticion: any;
    orderDraftId = null;
    htmlErrorCobertura = '<div class="col-lg-12"><h5 class="mb-0">Lo sentimos, no tienes cobertura de fibra</h5> a través de la red de República Móvil.</div>';
    private allSubscription: Subscription[] = [];

    constructor(
        private digoService: DigoService,
        private rmService: RepublicaMovilService,
        private normalizadorService: RmNormalizadorService,
        private amNormalizadorService: NormalizadorService
    ) { }

    ngOnInit(): void {
        this.allSubscription.push(this.digoService.getPDV()
            .subscribe((data: any) => {
                if (data != null) {
                    this.pdv = data;
                }
            })
        );

        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                if (data != null) {
                    this.typeOrder = data;
                }
            })
        );

        this.allSubscription.push(this.normalizadorService.getMuestraCobertura()
            .subscribe((value) => {
                this.muestraCobertura = value;
            })
        );

        // Recogemos los datos de la normalización cuando hay cambios
        this.allSubscription.push(this.normalizadorService.getDatosNormalizacion()
            .subscribe((valor) => {
                this.datosNormalizacion = valor;
            })
        );

        // Rellenamos las localidades
        this.allSubscription.push(this.normalizadorService.getLocalidades()
            .subscribe(async (local) => {
                this.localidades = local;
                await this.callIfOnlyOneResult();
            })
        );

        // Recuperamos el formulario de normalización
        this.allSubscription.push(this.normalizadorService.getFormularioNormalizacion()
            .subscribe((formulario) => {
                this.formularioNormalizacion = formulario;
            })
        );

        // Errores petición http o direcciones vacias
        this.allSubscription.push(this.normalizadorService.getErrorPeticionCobertura()
            .subscribe((value) => {
                this.muestraErrorPeticion = value;
            })
        );

        this.allSubscription.push(this.normalizadorService.getMsgErrorCobertura()
            .subscribe((value) => {
                this.msgErrorPeticion = value;
            })
        );
    }

    callIfOnlyOneResult() {
        if (this.localidades !== null && this.localidades.length === 1) {
            this.formGroup.get('localidadCobertura').patchValue(this.localidades[0]);
            this.onChangeLocalidad(this.localidades[0]);
        }
    }

    // SETTERS
    // Filtramos y seteamos el valor de las direcciones sugeridas
    setDireccionesSugeridas(localidad) {
        const dirSugeridas = this.datosNormalizacion
            .filter((el) => {
                if (el.streetName == null) {
                    return null;
                }
                // return el.city ? el.city.toUpperCase() : el.city === localidad ? localidad.toUpperCase() : localidad;
                return el.city && el.city !== '' ? (el.city.toUpperCase() === localidad.toUpperCase()) : null;
            })
            .map((el) => {
                const valorTexto = (el.streetType ? el.streetType.toUpperCase() + ' , ' : '') +
                    (el.streetName ? el.streetName.toUpperCase() + ' , ' : '') +
                    (el.streetNr ? el.streetNr + ' , ' : '') +
                    (el.postCode ? el.postCode : '');
                return {
                    streetType: el.streetType ? el.streetType.toUpperCase() : el.streetType,
                    streetName: el.streetName ? el.streetName.toUpperCase() : el.streetName,
                    streetNr: el.streetNr,
                    postCode: el.postCode,
                    stateOrProvince: el.stateOrProvince,
                    texto: valorTexto
                };
            });

        this.direccionesSugeridas = this.getUnique(dirSugeridas, 'texto');
        if (this.direccionesSugeridas.length === 1) {
            this.onChangeDireccionesSugeridas(this.direccionesSugeridas[0]);
        }
    }

    setPlantas(dir) {
        this.plantas = this.datosNormalizacion
            .filter((el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.formGroup.value.localidadCobertura ? this.formGroup.value.localidadCobertura.toUpperCase() : this.formGroup.value.localidadCobertura) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (dir.streetType ? dir.streetType.toUpperCase() : dir.streetType) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (dir.streetName ? dir.streetName.toUpperCase() : dir.streetName) &&
                    el.streetNr === dir.streetNr &&
                    el.postCode === dir.postCode;
            })
            .map((el) => el.floorNumber_translation)
            .filter((value, index, self) => self.indexOf(value) === index);
    }

    // Asignamos en este punto las direcciones filtradas por si solo queda una (no hay opciones que mostrar)
    setConsulta() {
        this.consulta = this.datosNormalizacion
            .filter((el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.formGroup.value.localidadCobertura ? this.formGroup.value.localidadCobertura.toUpperCase() : this.formGroup.value.localidadCobertura) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (this.formGroup.value.tipoViaCobertura ? this.formGroup.value.tipoViaCobertura.toUpperCase() : this.formGroup.value.tipoViaCobertura) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (this.formGroup.value.nombreViaCobertura ? this.formGroup.value.nombreViaCobertura.toUpperCase() : this.formGroup.value.nombreViaCobertura) &&
                    el.streetNr === this.formGroup.value.numeroCobertura &&
                    el.postCode === this.formGroup.value.codigoPostalCobertura &&
                    el.floorNumber_translation === this.formGroup.value.plantaCobertura;
            });
    }

    // Consulta sin campo planta obligatorio
    setConsultaNinguna() {
        this.consulta = this.datosNormalizacion
            .filter((el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.formGroup.value.localidadCobertura ? this.formGroup.value.localidadCobertura.toUpperCase() : this.formGroup.value.localidadCobertura) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (this.formGroup.value.tipoViaCobertura ? this.formGroup.value.tipoViaCobertura.toUpperCase() : this.formGroup.value.tipoViaCobertura) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (this.formGroup.value.nombreViaCobertura ? this.formGroup.value.nombreViaCobertura.toUpperCase() : this.formGroup.value.nombreViaCobertura) &&
                    el.streetNr === this.formGroup.value.numeroCobertura &&
                    el.postCode === this.formGroup.value.codigoPostalCobertura;
            });
    }

    // Consultamos si hay opciones para bis duplicado
    setBis(selectedEmpty?) {
        this.bisOption = this.consulta
            // .filter((el) => el.streetNrSuffix_translation)
            .map((el) => el.streetNrSuffix_translation ? el.streetNrSuffix_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.bisOption && this.bisOption.length === 1 && this.bisOption[0] === 'No tiene' && this.formGroup.get('bisCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.bisOption = null;
        }
    }

    // Consultamos si hay opciones para bloque
    setBloque(selectedEmpty?) {
        this.bloqueOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].subUnitNumber_translation)
            .map((el) => el.geographicSubAddress[0].subUnitNumber_translation ? el.geographicSubAddress[0].subUnitNumber_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.bloqueOption && this.bloqueOption.length === 1 && this.bloqueOption[0] === 'No tiene' && this.formGroup.get('bloqueCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.bloqueOption = null;
        }

        this.bloqueLabel = this.consulta
            .filter((el) => el.geographicSubAddress[0].subUnitType_translation)
            .map((el) => el.geographicSubAddress[0].subUnitType_translation)
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.bloqueLabel && this.bloqueLabel.length > 0) {
            this.bloqueLabel = this.bloqueLabel[0];
        }
    }

    // Consultamos si hay opciones para portal
    setPortal(selectedEmpty?) {
        this.portalOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].buildingName)
            .map((el) => el.geographicSubAddress[0].buildingName ? el.geographicSubAddress[0].buildingName : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.portalOption && this.portalOption.length === 1 && this.portalOption[0] === 'No tiene' && this.formGroup.get('portalCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.portalOption = null;
        }
    }

    // Consultamos si hay opciones para escalera
    setEscalera(selectedEmpty?) {
        this.escaleraOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].stairCase_translation)
            .map((el) => el.geographicSubAddress[0].stairCase_translation ? el.geographicSubAddress[0].stairCase_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.escaleraOption && this.escaleraOption.length === 1 && this.escaleraOption[0] === 'No tiene' && this.formGroup.get('escaleraCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.escaleraOption = null;
        }
    }

    // Consultamos si hay opciones para tipo puerta
    setTipoPuerta(selectedEmpty?) {
        this.tipoPuertaOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].doorType_translation)
            .map((el) => el.geographicSubAddress[0].doorType_translation ? el.geographicSubAddress[0].doorType_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.tipoPuertaOption && this.tipoPuertaOption.length === 1 && this.tipoPuertaOption[0] === 'No tiene' && this.formGroup.get('tipoPuertaCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.tipoPuertaOption = null;
        }
    }

    // Consultamos si hay opciones para puerta
    setPuerta(selectedEmpty?) {
        this.puertaOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].door)
            .map((el) => el.geographicSubAddress[0].door ? el.geographicSubAddress[0].door : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.puertaOption && this.puertaOption.length === 1 && this.puertaOption[0] === 'No tiene' && this.formGroup.get('puertaCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.puertaOption = null;
        }
    }

    // METODOS ON
    onChangeLocalidad(localidad) {
        // Limpiamos todas las variables para que afecte a la vista
        this.formGroup.patchValue({
            direccionesCobertura: '',
            tipoViaCobertura: '',
            nombreViaCobertura: '',
            numeroCobertura: '',
            codigoPostalCobertura: '',
            provinciaCobertura: '',
            plantaCobertura: '',
            bisCobertura: null,
            bloqueCobertura: null,
            portalCobertura: null,
            escaleraCobertura: null,
            tipoPuertaCobertura: null,
            puertaCobertura: null
        });
        this.direccionesSugeridas = null;
        this.plantas = null;
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        // Ocultamos botones de consulta
        this.muestraBotonesCobertura = false;
        this.muestraBotonNinguna = false;
        this.formGroup.get('localidadCobertura').patchValue(localidad);
        this.setDireccionesSugeridas(localidad);
    }

    onChangeDireccionesSugeridas(dir) {
        this.formGroup.patchValue({
            plantaCobertura: '',
            bisCobertura: null,
            bloqueCobertura: null,
            portalCobertura: null,
            escaleraCobertura: null,
            tipoPuertaCobertura: null,
            puertaCobertura: null
        });
        this.plantas = null;
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        // Mostramos boton ninguna anteriores
        this.muestraBotonNinguna = true;
        this.muestraBotonesCobertura = false;
        // Asignamos los valores al formGroup para que sea accesible desde todo el formulario
        this.formGroup.get('direccionesCobertura').patchValue(dir.texto ? dir.texto : (dir.streetName ? dir.streetName.toUpperCase() : dir.streetName));
        this.formGroup.get('tipoViaCobertura').patchValue(dir.streetType);
        this.formGroup.get('nombreViaCobertura').patchValue(dir.streetName ? dir.streetName.toUpperCase() : dir.streetName);
        this.formGroup.get('numeroCobertura').patchValue(dir.streetNr);
        this.formGroup.get('codigoPostalCobertura').patchValue(dir.postCode);
        this.formGroup.get('provinciaCobertura').patchValue(dir.stateOrProvince ? dir.stateOrProvince.toUpperCase() : dir.stateOrProvince);

        this.setPlantas(dir);
    }

    onChangePlanta() {
        this.resetControlsForm();
        // Limpiamos todas las variables para que afecte a la vista
        this.formGroup.patchValue({
            bisCobertura: null,
            bloqueCobertura: null,
            portalCobertura: null,
            escaleraCobertura: null,
            tipoPuertaCobertura: null,
            puertaCobertura: null
        });
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        // Mostramos botones de consulta
        this.muestraBotonesCobertura = true;
        // Rellenamos las opciones si hay resultado para ellas
        this.setConsulta();
        this.setBis();
        this.setBloque();
        this.setPortal();
        this.setEscalera();
        this.setTipoPuerta();
        this.setPuerta();
    }

    // Comprobamos si existe consulta para los datos seleccionados, si no existe se añaden las
    // validaciones de las opciones para que salte el error de campo obligatorio
    // compruebaSiExisteConsulta() {
    //     if (this.consulta === null) {
    //         return;
    //     }
    //     const tmp = this.consulta.filter(
    //         (el) => {
    //             return el.geographicSubAddress[0].levelNumber === this.formGroup.value.plantaCobertura &&
    //                 el.streetNrSuffix === this.formGroup.value.bisCobertura &&
    //                 el.geographicSubAddress[0].subUnitType === this.formGroup.value.bloqueCobertura &&
    //                 el.geographicSubAddress[0].buildingName === this.formGroup.value.portalCobertura &&
    //                 el.geographicSubAddress[0].stairCase === this.formGroup.value.escaleraCobertura &&
    //                 el.geographicSubAddress[0].doorType === this.formGroup.value.tipoPuertaCobertura &&
    //                 el.geographicSubAddress[0].door === this.formGroup.value.puertaCobertura;
    //         }
    //     ).map((el) => {
    //         return el;
    //     });
    //     if (tmp !== null && tmp.length > 0) {
    //         // Si existe consulta reseteamos los errores y asignamos la consulta
    //         this.resetControlsForm();
    //         this.consulta = tmp;
    //     } else {
    //         // Si no añadimos las validaciones para que se muestren los errores
    //         this.addAllValidationsCobertura();
    //     }
    // }

    // Retroalimentamos la consulta para que solo nos muestre las opciones correctas para lo seleccionado
    onSelectOpcion(key, value) {
        let selectedEmptyMain = false;
        let selectedEmpty = {
            bis: false,
            bloque: false,
            portal: false,
            escalera: false,
            tipoPuerta: false,
            puerta: false
        };
        if (value === '') {
            return;
        }
        if (value === 'No tiene') {
            value = null;
            selectedEmptyMain = true;
        }
        // bis
        if (key === 'streetNrSuffix') {
            this.consulta = this.consulta
            .filter((el) => el[key + '_translation'] === value)
            .map((el) => el);

            selectedEmpty.bis = selectedEmptyMain;
        }
        // Bloque
        if (key === 'subUnitNumber') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key + '_translation'] === value)
                .map((el) => el);

            selectedEmpty.bloque = selectedEmptyMain;
        }
        // Portal
        if (key === 'buildingName') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key] === value)
                .map((el) => el);

            selectedEmpty.portal = selectedEmptyMain;
        }
        // Escalera
        if (key === 'stairCase') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key + '_translation'] === value)
                .map((el) => el);

            selectedEmpty.escalera = selectedEmptyMain;
        }
        // Tipo puerta
        if (key === 'doorType') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key + '_translation'] === value)
                .map((el) => el);

            selectedEmpty.tipoPuerta = selectedEmptyMain;
        }
        // Puerta
        if (key === 'door') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key] === value)
                .map((el) => el);

            selectedEmpty.puerta = selectedEmptyMain;
        }
        this.setBis(selectedEmpty.bis);
        this.setBloque(selectedEmpty.bloque);
        this.setPortal(selectedEmpty.portal);
        this.setEscalera(selectedEmpty.escalera);
        this.setTipoPuerta(selectedEmpty.tipoPuerta);
        this.setPuerta(selectedEmpty.puerta);
        this.addAllValidationsCobertura();
    }

    onConsultarCobertura() {
        let currentZip = this.formGroup.get('codigoPostalCobertura').value;

        if (this.formularioNormalizacion != null && (currentZip === null || currentZip === '')) {
            currentZip = this.formularioNormalizacion.get('codigoPostalNormaliza').value;
            this.formGroup.get('codigoPostalCobertura').patchValue(currentZip);
        }

        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura('');
        this.addAllValidationsCobertura();
        // this.compruebaSiExisteConsulta();
        this.validateAllFormFields(this.formGroup);
        if (this.formGroup.status === 'VALID') {
            this.onChangeLoading(true);
            this.formGroup.disable();
            this.normalizadorService.setResultadoCobertura(this.formGroup);
            this.normalizadorService.setMuestraNormalizacion(false);
            this.normalizadorService.setMuestraCobertura(false);
            this.amNormalizadorService.setRealtechnology(false);

            let body;
            if (this.consulta.length > 1) {
                const found = this.consulta.find(x => x.geographicSubAddress && x.geographicSubAddress.length && x.geographicSubAddress[0].subUnitNumber_translation === this.formGroup.get('bloqueCobertura').value);
                body = found ? found : this.consulta[0];
            } else {
                body = this.consulta[0];
            }

            this.consultaCoberturaRM(body);
            this.consultaCoberturaAmena(body);
        } else {
            this.onChangeLoading(false);
        }
    }

    consultaCoberturaRM(body: any) {
        this.normalizadorService.consultaCobertura(body).subscribe((data: any) => {
            // Solucion para que al cambiar el endpoint no falle del comun al rm\
            if (data.msg) {
                data = data.msg;
            }

            if (data.cimaGescalCode && data.cimaGescalCode !== '' && data.realtechnology && data.realtechnology.length > 0 && data.technology[0] !== 'NINGUNO') {
                this.formGroup.get('resultadoConsultaCobertura').patchValue(data);
                this.normalizadorService.setThereIsCoverage(true);
                this.clearFormGroup();
                this.normalizadorService.setResultadoCobertura(this.formGroup);
                this.onChangeLoading(false);
                this.formGroup.enable();
                this.formGroup.get('provinciaCobertura').disable();
            } else {
                this.normalizadorService.setThereIsCoverage(false);
                this.normalizadorService.setErrorPeticionCobertura(true);
                this.normalizadorService.setMsgErrorCobertura(this.htmlErrorCobertura);
                this.onChangeLoading(false);
                this.formGroup.enable();
                this.formGroup.get('provinciaCobertura').disable();
            }
            if (this.pdv.permissions.AMENA !== 'PERMITIR_ACTIVACIONES_AMENA') {
                this.amNormalizadorService.setRealtechnology(null);
            }
        }, (error) => {
            const msgError = 'Ha ocurrido un error al realizar la consulta. Por favor inténtalo más tarde.';

            this.normalizadorService.setErrorPeticionCobertura(true);
            this.normalizadorService.setMsgErrorCobertura(msgError);
            this.onChangeLoading(false);
            this.formGroup.enable();
            this.formGroup.get('provinciaCobertura').disable();
            if (this.pdv.permissions.AMENA !== 'PERMITIR_ACTIVACIONES_AMENA') {
                this.amNormalizadorService.setRealtechnology(null);
            }
            console.error(error);
        });
    }

    consultaCoberturaAmena(body: any) {
        if (this.pdv.permissions.AMENA === 'PERMITIR_ACTIVACIONES_AMENA' /* && this.typeOrder === orderType.CONVERGENT*/) {
            this.amNormalizadorService.consultaCobertura(body)
                .subscribe((data: any) => {
                    if (data.msg) {
                        data = data.msg;
                    }

                    if (data.cimaArvatoCode && data.cimaArvatoCode !== '' && data.realtechnology && data.realtechnology.length && data.realtechnology.find(technology => technology.real)) {
                        this.formGroup.get('resultadoConsultaCobertura').patchValue(data);
                        this.formGroup.get('numeroApartamento').patchValue(body && body.apartmentNumber ? body.apartmentNumber : '');
                        this.amNormalizadorService.setRealtechnology(data.realtechnology);                    
                        this.clearFormGroup();    
                        this.normalizadorService.setResultadoCoberturaAmena(this.getValueForCobertura(this.formGroup, body));
                    } else {
                        this.amNormalizadorService.setRealtechnology(null);
                    }
                }, (error) => {
                    console.error('[AMENA]', error);
                    this.amNormalizadorService.setRealtechnology(null);
                });
        } else {
            console.log('PDV sin permiso de vender Amena');
        }
    }

    onConsultarNingunaAnteriores() {
        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura('');
        this.resetControlsForm();
        this.clearValidations('plantaCobertura');
        this.clearValidations('bisCobertura');
        this.clearValidations('bloqueCobertura');
        this.clearValidations('portalCobertura');
        this.clearValidations('escaleraCobertura');
        this.clearValidations('tipoPuertaCobertura');
        this.clearValidations('puertaCobertura');
        if (this.formGroup.status === 'VALID') {
            this.onChangeLoading(true);
            this.formGroup.disable();
            this.setConsultaNinguna();
            this.normalizadorService.setResultadoCobertura(this.formGroup);
            this.normalizadorService.setMuestraNormalizacion(false);
            this.normalizadorService.setMuestraCobertura(false);
            this.formGroup.patchValue({
                bisCobertura: null,
                bloqueCobertura: null,
                portalCobertura: null,
                escaleraCobertura: null,
                tipoPuertaCobertura: null,
                puertaCobertura: null
            });
            const body = this.limpiarConsultaNingunaAnteriores(this.consulta);

            this.consultarNingunaAnterioresRM(body);
            this.consultarNingunaAnterioresAmena(body);
        } else {
            this.onChangeLoading(false);
            this.formGroup.enable();
            this.formGroup.get('provinciaCobertura').disable();
        }
    }

    consultarNingunaAnterioresRM(body) {
        this.normalizadorService.consultaNingunaAnteriores(body).subscribe((data: any) => {
            if (data.msg) {
                data = data.msg;
            }

            if (data.cimaGescalCode && data.cimaGescalCode !== '' && data.realtechnology && data.realtechnology.length > 0 && data.technology[0] !== 'NINGUNO') {
                this.formGroup.get('resultadoConsultaCobertura').patchValue(data);
                this.normalizadorService.setThereIsCoverage(true);
                this.normalizadorService.setResultadoCobertura(this.formGroup);
                this.onChangeLoading(false);
                this.formGroup.enable();
                this.formGroup.get('provinciaCobertura').disable();
            } else {
                this.normalizadorService.setThereIsCoverage(false);
                this.normalizadorService.setErrorPeticionCobertura(true);
                this.normalizadorService.setMsgErrorCobertura(this.htmlErrorCobertura);
                this.onChangeLoading(false);
                this.formGroup.enable();
                this.formGroup.get('provinciaCobertura').disable();
            }
        }, (error) => {
            const msgError = 'Ha ocurrido un error al realizar la consulta. Por favor inténtalo más tarde.';

            this.normalizadorService.setErrorPeticionCobertura(true);
            this.normalizadorService.setMsgErrorCobertura(msgError);
            this.onChangeLoading(false);
            this.formGroup.enable();
            this.formGroup.get('provinciaCobertura').disable();

            console.error(error);
        });
    }

    consultarNingunaAnterioresAmena(body) {
        if (this.pdv.permissions.AMENA === 'PERMITIR_ACTIVACIONES_AMENA' /*&& this.typeOrder === orderType.CONVERGENT*/) {
            this.amNormalizadorService.consultaNingunaAnteriores(body).subscribe((data: any) => {
                if (data.msg) {
                    data = data.msg;
                }

                if (data.cimaArvatoCode && data.cimaArvatoCode !== '' && data.realtechnology && data.realtechnology.length > 0 && data.technology[0] !== 'NINGUNO') {
                    this.amNormalizadorService.setRealtechnology(data.realtechnology);
                    this.normalizadorService.setResultadoCoberturaAmena(data);
                }
            }, (error) => {
                console.error('[AMENA]', error);
            });
        }
    }

    limpiarConsultaNingunaAnteriores(consultaInicial) {
        if (consultaInicial && consultaInicial.length) {
            let consulta = '';
            consultaInicial[0].geographicSubAddress[0].levelNumber = null;
            consultaInicial[0].streetNrSuffix = null;
            consultaInicial[0].geographicSubAddress[0].subUnitType = null;
            consultaInicial[0].geographicSubAddress[0].subUnitNumber = null;
            consultaInicial[0].geographicSubAddress[0].buildingName = null;
            consultaInicial[0].geographicSubAddress[0].stairCase = null;
            consultaInicial[0].geographicSubAddress[0].doorType = null;
            consultaInicial[0].apartmentNumber = null;
            consultaInicial[0].geographicSubAddress[0].door = null;
            consultaInicial[0].staircaseNumber = null;
            consultaInicial[0].streetNrLast = null;
            consultaInicial[0].streetNrLastSuffix = null;
            consultaInicial[0].streetNrSuffix = null;
            // Si existe código gescal lo limpiamos
            for (let i = 0; i < consultaInicial[0].ospAddressExternalId.length; i++) {
                if (consultaInicial[0].ospAddressExternalId[i].refId !== null) {
                    if (consultaInicial[0].ospAddressExternalId[i].refId === 'gescal') {
                        consultaInicial[0].ospAddressExternalId[i].externalId = null;
                    }
                }
            }
            consulta = consultaInicial[0];

            return consulta;
        }
    }

    // Restablece el formulario a la configuración inicial
    onReset(formCobertura) {
        this.formGroup.reset();
        this.formularioNormalizacion.enable();
        this.formularioNormalizacion.reset();
        this.formularioNormalizacion.get('provinciaNormaliza').disable();
        this.localidades = null;
        this.direccionesSugeridas = null;
        this.plantas = null;
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        this.normalizadorService.resetNormalizacion();
        this.normalizadorService.setLocalidades(null);
        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura('');

        this.resetControlsForm();
        // this.draftService.removeDraft(this.orderDraftId);
        // this.draftService.orderInit();

    }

    // VALIDACIONES

    // Añade validación al elemento enviado, solo si hay resultados para ese elemento
    addRequiredControl(nombreControl, elemento) {
        if (elemento) {
            const identificador = this.formGroup.get(nombreControl);
            if (elemento.length) {
                identificador.setValidators([Validators.required]);
            } else {
                this.clearValidations(nombreControl);
            }
        } else {
            this.clearValidations(nombreControl);
        }
    }

    // Añade validaciones para todo el formulario de cobertura
    addAllValidationsCobertura() {
        this.addRequiredControl('bisCobertura', this.bisOption);
        this.addRequiredControl('bloqueCobertura', this.bloqueOption);
        this.addRequiredControl('portalCobertura', this.portalOption);
        this.addRequiredControl('escaleraCobertura', this.escaleraOption);
        this.addRequiredControl('tipoPuertaCobertura', this.tipoPuertaOption);
        this.addRequiredControl('puertaCobertura', this.puertaOption);
    }

    // Reset errores de validación para la consulta ninguna de las anteriores
    resetControlsForm() {
        this.formGroup.get('bisCobertura').clearValidators();
        this.formGroup.get('bloqueCobertura').clearValidators();
        this.formGroup.get('portalCobertura').clearValidators();
        this.formGroup.get('escaleraCobertura').clearValidators();
        this.formGroup.get('tipoPuertaCobertura').clearValidators();
        this.formGroup.get('puertaCobertura').clearValidators();
    }

    // Comprueba si existen errores de validacion y hace saltar estos errores
    validateAllFormFields(formGroup: FormGroup | FormArray): boolean {
        const keysArray = formGroup instanceof FormGroup ? Object.values(formGroup.controls) : formGroup.controls;
        keysArray.forEach(control => {
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: false});
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup || control instanceof FormArray) {
                this.validateAllFormFields(control);
            }
        });
        return formGroup.invalid;
    }

    // Funcion para limpiar las validaciones de un campo del formulario
    clearValidations(nameForm: string) {
        this.formGroup.get(nameForm).clearValidators();
        this.formGroup.get(nameForm).setValidators([]);
        this.formGroup.get(nameForm).updateValueAndValidity();
    }

    // Función para manejar los mensajes de error
    public errorHandling = (control: string, error: string) => {
        if (this.formGroup.get(control).invalid && (this.formGroup.get(control).dirty || this.formGroup.get(control).touched)) {
            return this.formGroup.controls[control].hasError(error);
        }
    }

    // UTILS

    // Devuelve valores unicos para un identificador dado
    getUnique(array, identificador) {
        const unique = array
            .map(e => e[identificador])
            .map((e, i, final) => final.indexOf(e) === i && i)
            .filter(e => array[e]).map(e => array[e]);

        return unique;
    }


    onChangeLoading(state) {
        if (state === true) {
            this.isLoading = true;
            this.textDefault = 'Comprobando ...';
        } else {
            this.isLoading = false;
            this.textDefault = 'Comprobar cobertura';
        }
    }

    filterByValue(accumulator, current) {
        const x = accumulator.find(item => item.val === current.val);

        if (!x) {
            return accumulator.concat([current]);
        } else {
            return accumulator;
        }
    }

    clearFormGroup() {
        for (const field in this.formGroup.controls) {
            if (this.formGroup.get(field).value === 'No tiene') {
                this.formGroup.get(field).patchValue(null);
            }
        }
    }

    getValueForCobertura(formGroup, resultCobertura?) {
        if (resultCobertura) {
            formGroup.get('plantaCobertura').patchValue(resultCobertura.floorNumber);
            formGroup.get('bisCobertura').patchValue(resultCobertura.streetNrSuffix);
            if (resultCobertura.geographicSubAddress && resultCobertura.geographicSubAddress.length) {
                formGroup.get('bloqueCobertura').patchValue(resultCobertura.geographicSubAddress[0].subUnitNumber);
                formGroup.get('escaleraCobertura').patchValue(resultCobertura.geographicSubAddress[0].stairCase);
                formGroup.get('tipoPuertaCobertura').patchValue(resultCobertura.geographicSubAddress[0].doorType);
            }
        }
        return formGroup;
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
